export default "__VITE_ASSET__dd0bc9f0__"